__turbopack_context__.v({
  "card": "RepairDetailsReadOnlySection-module-scss-module__7fHUYq__card",
  "content": "RepairDetailsReadOnlySection-module-scss-module__7fHUYq__content",
  "section": "RepairDetailsReadOnlySection-module-scss-module__7fHUYq__section",
  "title": "RepairDetailsReadOnlySection-module-scss-module__7fHUYq__title",
});
